import { FilterOption } from "@ugg/shared/interfaces/filter-manager.interface";

// Augment rarity filter options for the ARAM Mayhem augment surfaces (the
// by-rarity tier list and the per-champion augments module).
//
// The URL values are deliberately NOT the pipeline's `k*` enum keys
// (`kPrismatic`): those are a wire format, and `?rarity=prismatic` is what
// belongs in a link someone shares. Consumers map back through
// AUGMENT_RARITY_PARAM_TO_KEY in the augment filter module.
//
// "all" is the page default, so validateQueryParams strips it from the URL —
// the unfiltered view stays at a clean `?`-free address.
export const AUGMENT_RARITY_ALL = "all";

export const AUGMENT_RARITY_OPTIONS: FilterOption[] = [
  { value: AUGMENT_RARITY_ALL, label: "All Rarities" },
  { value: "prismatic", label: "Prismatic" },
  { value: "gold", label: "Gold" },
  { value: "silver", label: "Silver" },
];
